// core
import { createFeatureSelector, createSelector } from '@ngrx/store';

// share
import { RecruitmentReducer } from '../reducers';

export const selectRecruitmentFeature = createFeatureSelector<RecruitmentReducer.RecruitmentState>(RecruitmentReducer.featureName);

export const selectRecruitmentDetail = createSelector(selectRecruitmentFeature, (state: RecruitmentReducer.RecruitmentState) => state.detail);
